import { render } from "./AssistantRecruit.vue?vue&type=template&id=3b5dbb18&scoped=true"
import script from "./AssistantRecruit.vue?vue&type=script&lang=js"
export * from "./AssistantRecruit.vue?vue&type=script&lang=js"

import "./AssistantRecruit.vue?vue&type=style&index=0&id=3b5dbb18&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b5dbb18"]])

export default __exports__